import * as smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();
